import {gql} from "@apollo/client";

export const GET_PICKUP_APPOINTMENT_COUNTS = gql`
    query PickupAppointmentCountsQuery(
        $filters: PickupAppointmentFiltersTypeInput
    ) {
        getPickupAppointmentCounts(filters: $filters) {
            pendingCount
            confirmedCount
        }
    }
`;

export interface PickupAppointmentCountsResponse {
    getPickupAppointmentCounts: {
        pendingCount: number;
        confirmedCount: number;
    };
}
